import { useEffect, useState } from 'react';
import styled from 'styled-components';
import LoanInfoService from '../../../service/LoanInfo';
import { DetailNoDataColumn } from '../../components/nodata/NoData';
import { s } from './CourtInformation.styles';
import { BasicInfo, ItemHistory } from './data';
import Loading from '../../../func/components/loading/LoadingCircle';
import Footer from '../../components/footer/Footer';
import { useNavigate } from 'react-router-dom';
import { BorderButton } from '../../../sidebar/SideInfoStyle';
const IncidentDetails = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>();
  const [divHistory, setDivHistory] = useState<string[][]>([]);
  const [appealHistory, setAppealHistory] = useState<string[][]>([]);
  const [relateHistory, setRelateHistory] = useState<string[][]>([]);
  const [itemHistory, setItemHistory] = useState<ItemHistory>();
  const [listHistory, setListHistory] = useState<string[][]>([]);
  const [partyHistory, setPartyHistory] = useState<string[][]>([]);
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const iidx = params.get('iidx');
  const exportIcon = '/assets/images/icon/Icon_Export_gray.svg'
  const arrowIcon = '/assets/images/icon/Arrow.svg'
  const navigate = useNavigate();
  const getData = async (iidx: number) => {
    
    try {
      setLoading(true);
      const res = await LoanInfoService.courtDetail(iidx);
      setBasicInfo(res.data.case_detail.basic_info);
      setDivHistory(res.data.case_detail.div_history || []);
      setAppealHistory(res.data.case_detail.appeal_history || []);
      setRelateHistory(res.data.case_detail.relate_history || []);
      setItemHistory(res.data.case_detail.item_history[0]);
      setListHistory(res.data.case_detail.list_history || []);
      setPartyHistory(res.data.case_detail.party_history || []);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (iidx) {
      getData(Number(iidx));
    }
  }, []);

  useEffect(() => {
  window.scrollTo(0, 0);
  }, [iidx]);

  const decodeHtmlEntities = (html: any) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  return (
    <s.Container>
      {loading && <Loading />}
      {!loading && (
        <s.Inner>
          <TitleWrapper>
          <PageTitleBox>
            <BackButton onClick={() => window.close()}>
              <img src={arrowIcon} alt="" />
            </BackButton>
              <div>{basicInfo?.case_no} 사건내역</div>
               </PageTitleBox>
             <IconWrapper>
              <img src={exportIcon} alt="" style={{ width: '24px', height: '24px' }}/>
            </IconWrapper>
           
          </TitleWrapper>
          <InnerItem>
          {/* 사건기본내역 */}
          <s.Content>
            <s.ContentTitleBox>사건기본내역</s.ContentTitleBox>
            <s.Table>
              <tbody>
                <s.Row>
                  <s.TitleCell width="100px">사건번호</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.case_no}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">사건명</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.case_name}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">접수일자</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.regist_date}
                  </s.ContentCell>
                  </s.Row>
                  <s.Row>
                  <s.TitleCell width="100px">개시결정일자</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.set_open_date}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">담당계</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={3}>
                    {decodeHtmlEntities(basicInfo?.manager)}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">청구금액</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.billing_price}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">
                    사건항고/ <br />
                    정지여부{' '}
                  </s.TitleCell>
                  <s.ContentCell width="auto"></s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">종국결과</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.end_result}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">종국일자</s.TitleCell>
                  <s.ContentCell width="auto">
                    {basicInfo?.end_date}
                  </s.ContentCell>
                </s.Row>
              </tbody>
            </s.Table>
          </s.Content>
          {/*배당요구종기내역*/}
          <s.Content>
            <s.ContentTitleBox>배당요구종기내역</s.ContentTitleBox>
            <s.Table>
              <thead>
                <s.Row>
                  <s.TableHeadTh width="320px">목록번호/<br/>배달요구종기일</s.TableHeadTh>
                  <s.TableHeadTh width="538px">소재지</s.TableHeadTh>
                </s.Row>
              </thead>
              <tbody>
                {divHistory &&
                  divHistory.length > 0 &&
                  divHistory.map((data, index) => (
                    <s.Row key={index}>
                      <s.ContentCell
                        width="160px"
                        textAlign="left"
                        border={true}
                        style={{borderRight:'1px solid #E1E2E4'}}
                      >
                        <div>{data[0]} / {data[2]}</div>
                      </s.ContentCell>
                      <s.ContentCell
                        width="538px"
                        textAlign="center"
                        border={true}
                      >
                        {data[1]}
                      </s.ContentCell>
                    </s.Row>
                  ))}
                {divHistory.length === 0 && (
                  <DetailNoDataColumn absorption={3} />
                )}
              </tbody>
            </s.Table>
          </s.Content>
          {/*항고내역*/}
          <s.Content>
              <s.ContentTitleBox>항고내역</s.ContentTitleBox>
              <TableScrollWrapper style={{ width: '100%' }}>
            <s.Table style={{ minWidth: '533px', width: 'fit-content' }}>
              <thead>
                <s.Row>
                  <s.TableHeadTh width="auto" rowSpan={2} style={{ padding: '22px 12px' }}>
                    <HeadTitle>물건번호 / 기일</HeadTitle> 
                  </s.TableHeadTh>
                  <s.TableHeadTh width="auto">
                    <HeadTitle>항고접수일자<br /> 결과</HeadTitle>
                  </s.TableHeadTh>
                  <s.TableHeadTh width="auto" >
                    <HeadGroup>
                      <HeadLabel>항고</HeadLabel>
                      <HeadSubText>사건번호 / 항고결과</HeadSubText>
                    </HeadGroup>
                  </s.TableHeadTh>
                  <s.TableHeadTh width="auto" >
                    <HeadGroup>
                      <HeadLabel>재항고</HeadLabel>
                      <HeadSubText>사건번호 / 항고결과</HeadSubText>
                    </HeadGroup>
                  </s.TableHeadTh>
                  <s.TableHeadTh width="auto" rowSpan={2}>
                    <HeadTitle>확정여부</HeadTitle>
                  </s.TableHeadTh>
                </s.Row>

              </thead>
              <tbody>
                {appealHistory.length > 0 &&
                  appealHistory.map((data, index) => (
                    <>
                      <s.Row key={index}>
                        <s.ContentCell
                          width="88px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[0]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="88px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[1]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="88px"
                          border={true}
                          textAlign="center"
                        >
                          {data[2]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="100px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[3]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="151.5px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[4]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="100px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[5]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="151.5px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[6]}
                        </s.ContentCell>
                        <s.ContentCell
                          width="88px"
                          border={true}
                          textAlign="center"
                          rowSpan={2}
                        >
                          {data[7]}
                        </s.ContentCell>
                      </s.Row>
                      <s.Row>
                        <s.ContentCell
                          width="88px"
                          border={true}
                          textAlign="center"
                          style={{ borderRight: '1px solid #e8e9ea' }}
                        >
                          {data[8]}
                        </s.ContentCell>
                      </s.Row>
                    </>
                  ))}
                {appealHistory.length === 0 && (
                  <DetailNoDataColumn absorption={8} />
                )}
              </tbody>
                </s.Table>
                </TableScrollWrapper>
          </s.Content>
          {/* 관련사건내역 */}
          <s.Content>
            <s.ContentTitleBox>관련사건내역</s.ContentTitleBox>
            {relateHistory.length > 0 ? (
              relateHistory.map((data, index) => (
                <div key={index} style={{ borderTop:'1px solid #222222' }}>
                    <ItemBox>
                      <s.Label>관련법원</s.Label>
                      <s.ContentItem>{data[0]}</s.ContentItem>
                  </ItemBox>
                  <ItemBox>
                      <s.Label>관련사건번호</s.Label>
                      <s.ContentItem>{data[1]}</s.ContentItem>
                  </ItemBox>
                  <ItemBox>
                      <s.Label>관련사건구분</s.Label>
                      <s.ContentItem>{data[2]}</s.ContentItem>
                    </ItemBox>
                </div>
              ))
            ) : (
                  <DetailNoDataColumn absorption={3}  />
            )}
          </s.Content>
          {/* 물건내역*/}
          <s.Content>
            <s.ContentTitleBox>물건내역</s.ContentTitleBox>
            <s.Table>
              <tbody>
                <s.Row>
                  <s.TitleCell width="100px">물건번호</s.TitleCell>
                  <s.ContentCell width="auto">
                    {itemHistory?.item_no}
                    </s.ContentCell>
                  </s.Row>
                  <s.Row>
                  <s.TitleCell width="100px">물건용도</s.TitleCell>
                  <s.ContentCell width="140px">
                    {itemHistory?.zoning}
                    </s.ContentCell>
                  </s.Row>
                  <s.Row>
                  <s.TitleCell width="100px">
                    감정평가액 <br />
                    (최저매각가격)
                  </s.TitleCell>
                  <s.ContentCell width="140px">
                    {itemHistory?.appraised_price.replaceAll('<br>', '')}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">물건비고</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={5}>
                    {itemHistory?.item_etc}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">목록 1</s.TitleCell>
                  <s.ContentCell width="auto">
                    {itemHistory?.list[0].addr}
                    </s.ContentCell>
                    </s.Row>
                    <s.Row>
                  <s.TitleCell width="100px">목록구분</s.TitleCell>
                  <s.ContentCell width="140px">
                    {itemHistory?.list[0].type}
                    </s.ContentCell>
                    </s.Row>
                    <s.Row>
                  <s.TitleCell width="100px">비고</s.TitleCell>
                  <s.ContentCell width="140px">
                    {itemHistory?.list[0].etc}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">물건상태</s.TitleCell>
                  <s.ContentCell width="auto" colSpan={5}>
                    {itemHistory?.item_status}
                  </s.ContentCell>
                </s.Row>
                <s.Row>
                  <s.TitleCell width="100px">기일정보</s.TitleCell>
                  <s.ContentCell width="auto">
                    {itemHistory?.date_info}
                    </s.ContentCell>
                    </s.Row>
                    <s.Row>
                  <s.TitleCell width="100px">최근입찰결과</s.TitleCell>
                  <s.ContentCell width="auto">
                    {itemHistory?.recent_result}
                  </s.ContentCell>
                </s.Row>
              </tbody>
            </s.Table>
          </s.Content>
          {/* 목록내역 */}
          <s.Content>
            <s.ContentTitleBox>목록내역</s.ContentTitleBox>
            <s.Table>
              <thead>
                <s.Row>
                  <s.TableHeadTh width="160px">목록번호/ <br />목록구분</s.TableHeadTh>
                  <s.TableHeadTh width="377px">소재지</s.TableHeadTh>
                  <s.TableHeadTh width="160px">비고</s.TableHeadTh>
                </s.Row>
              </thead>
              <tbody>
              {listHistory.length > 0 ? (
                listHistory.map((data, index) => (
                  <s.Row key={index}>
                    {/* 목록번호 + 목록구분 한 셀에 표시 */}
                    <s.ContentCell
                      key="merged"
                      width="160px"
                      textAlign="center"
                      border={true}
                      style={{ borderRight: '1px solid #E1E2E4' }}
                    >
                      {data[0]} / {data[3]}
                    </s.ContentCell>

                    {/* 소재지 */}
                    <s.ContentCell
                      key="location"
                      width="377px"
                      textAlign="center"
                      border={true}
                      style={{ borderRight: '1px solid #E1E2E4' }}
                    >
                      {data[1]}
                    </s.ContentCell>

                    {/* 비고 */}
                    <s.ContentCell
                      key="note"
                      width="160px"
                      textAlign="center"
                      border={true}
                    >
                      {data[2]}
                    </s.ContentCell>
                  </s.Row>
                ))
              ) : (
                <DetailNoDataColumn absorption={3} />
              )}
            </tbody>
            </s.Table>
          </s.Content>
          {/* 당사자내역 */}
          <s.Content>
            <s.ContentTitleBox>당사자내역</s.ContentTitleBox>
            <s.Table style={{ marginBottom: '40px' }}>
             <thead>
              <s.Row>
                <s.TableHeadTh width="auto">당사자구분</s.TableHeadTh>
                <s.TableHeadTh width="auto">당사자명</s.TableHeadTh>
              </s.Row>
            </thead>
            <tbody>
              {partyHistory.length > 0 ? (
                partyHistory.map((data, index) => (
                  <s.Row key={index}>
                    <s.ContentCell
                      width="auto"
                      textAlign="center"
                      border={true}
                      style={{ borderRight: '1px solid #E1E2E4' }}
                    >
                      {data[0]} {/* 당사자구분 */}
                    </s.ContentCell>
                    <s.ContentCell
                      width="auto"
                      textAlign="center"
                      border={true}
                    >
                      {data[1]} {/* 당사자명 */}
                    </s.ContentCell>
                  </s.Row>
                ))
              ) : (
            <tr>
              <td colSpan={2}>
                <DetailNoDataColumn absorption={2} />
              </td>
            </tr>
            )}
          </tbody>
            </s.Table>
            </s.Content>
            </InnerItem>
        </s.Inner>
      )}
       <Footer/>
    </s.Container>
  );
};

export default IncidentDetails;

const TitleWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #70737C29;
  display: flex;
  align-items: center;
  padding: 15px 16px;
  color: #222222;
`

const PageTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  gap: 4px;
  align-items: center;

`

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 24px; 
  width: 100%;

 /* 스크롤바 디자인 */
  &::-webkit-scrollbar {
    height: 8px;
    background-color: #000;
  }

  &::-webkit-scrollbar-track {
     
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #999;
  }

  /* 화살표 숨기기 */
  &::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }
  scrollbar-color: #C1C1C1 #F0F0F0; /* Firefox */
  scrollbar-width: thin;
`;

const InnerItem = styled.div`
 padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const IconWrapper  = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const BackButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const HeadTitle = styled.div`
  font-size: 13px;
  font-weight: 500;
`

const HeadGroup = styled.div`
  font-size:13px;
  font-weight: 500;
`

const HeadLabel = styled.div`
  color: #222222;
`

const HeadSubText = styled.div``

const ItemBox = styled.div`
  display: flex;
  border-bottom: 1px solid #E1E2E4;
`;